<form [formGroup]="form">
  <h2 mat-dialog-title>Export Packing Slips</h2>
  <mat-dialog-content class="mat-typography">
    <section class="page-config">
      <h3>Page Size and Orientation</h3>
      <div class="row">
        <div class="col-6">
          <mat-form-field appearance="fill">
            <mat-label>Page Size</mat-label>
            <mat-select formControlName="pageSize">
              <mat-option [value]="EPackingSlipPageSizeOptions.A4">
                {{ EPackingSlipPageSizeOptions.A4 }}
              </mat-option>
              <mat-option [value]="EPackingSlipPageSizeOptions.LETTER">
                {{ EPackingSlipPageSizeOptions.LETTER }}
              </mat-option>
              <mat-option [value]="EPackingSlipPageSizeOptions.LEGAL">
                {{ EPackingSlipPageSizeOptions.LEGAL }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="col-6">
          <mat-form-field appearance="fill">
            <mat-label>Page Orientation</mat-label>
            <mat-select formControlName="pageOrientation">
              <mat-option [value]="EPackingSlipPageOrientationOptions.PORTRAIT">
                {{ EPackingSlipPageOrientationOptions.PORTRAIT }}
              </mat-option>
              <mat-option [value]="EPackingSlipPageOrientationOptions.LANDSCAPE">
                {{ EPackingSlipPageOrientationOptions.LANDSCAPE }}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
    </section>
    <section class="columns">
      <h3>Export Columns</h3>
      <div class="columns-list">
        <div *ngFor="let col of columns; index as i">
          <mat-checkbox [formControlName]="col.value">{{ col.label }}</mat-checkbox>
        </div>
      </div>
    </section>
    <section class="columns">
      <h3>Export Notes</h3>
      <div class="columns-list">
        <mat-checkbox formControlName="showCustomerNotesOption">
          Show Customer Notes
        </mat-checkbox>
      </div>
    </section>
    <section class="kit-config">
      <h3>Exporting KITs</h3>
      <mat-radio-group
        aria-label="Select an option"
        formControlName="showKitOption"
      >
        <mat-radio-button [value]="EPackingSlipShowKitOptions.KIT_COMPONENTS_ONLY"
          >Show KIT components (default)</mat-radio-button
        >
        <mat-radio-button [value]="EPackingSlipShowKitOptions.KIT_PRODUCT_ONLY"
          >Show KIT product only</mat-radio-button
        >
        <mat-radio-button [value]="EPackingSlipShowKitOptions.KIT_AND_COMPONENTS"
          >Show KIT and its components</mat-radio-button
        >
      </mat-radio-group>
    </section>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
      mat-button
      class="lum-button lum-button--secondary lum-button--medium"
      (click)="closeDialog()"
    >
      Cancel
    </button>
    <button
      mat-button
      class="lum-button lum-button lum-button--medium"
      (click)="onExportPackingSlip()"
    >
      <i class="fas fa-print"></i> Export Packing Slips
    </button>
  </mat-dialog-actions>
</form>
